import React, { useMemo } from 'react';
import { Box } from '@hiro-ui/bootstrap';
import { SearchResult } from '../types';
import styled from 'styled-components';
import { Link } from 'gatsby';

export interface ResultsProps {
  data: SearchResult[];
}

const Result = styled(Box)`
  border-radius: 12px;
  border-width: 2px;

  & > .link {
    color: ${({ theme }) => theme.colors.primary.default};
    margin-bottom: 0.5rem;
  }

  & > h2 {
    margin-top: 0;
    margin-bottom: 0.5rem;
  }

  &:after {
    content: '\f061';
    font-family: 'FontAwesome';
    color: ${({ theme }) => theme.colors.white.default};
    bottom: 0;
    position: absolute;
    right: 0;
    margin: 0.5rem;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.greyscale.light};
    width: 20px;
    height: 20px;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    overflow: hidden;
  }

  &:hover {
    color: ${({ theme }) => theme.colors.primaryText.active};

    &::after {
      background-color: ${({ theme }) => theme.colors.primary.default};
    }
  }
`;

const ResultLink = styled(Link)`
  text-decoration: none;

  &:not(:last-child) > ${Result} {
    margin-bottom: 1.5rem;
  }
`;

export const Results: React.FC<ResultsProps> = ({ data }) => {
  if (data.length === 0) {
    return null;
  }

  const contents = useMemo(
    () =>
      data.map((d) => (
        <ResultLink to={d.url}>
          <Result padded bordered>
            <h2>{d.main}</h2>
            <span className="link">{d.url}</span>
            {d.subtitle && <span>{d.subtitle}</span>}
          </Result>
        </ResultLink>
      )),
    [data],
  );

  return <>{contents}</>;
};
